/**
 * <s-cursor-glow> — a soft cold-blue light that trails the pointer.
 * Only runs for fine pointers and when the visitor allows motion.
 */
class SCursorGlow extends HTMLElement {
  #ac;
  #frame = 0;
  #x = 0;
  #y = 0;
  #tx = 0;
  #ty = 0;

  connectedCallback() {
    const allowed = window.matchMedia('(pointer: fine)').matches;
    if (!allowed) return;
    this.#ac = new AbortController();
    const { signal } = this.#ac;

    window.addEventListener('pointermove', (event) => {
      this.#tx = event.clientX;
      this.#ty = event.clientY;
      if (!this.hasAttribute('data-active')) {
        this.#x = this.#tx;
        this.#y = this.#ty;
        this.setAttribute('data-active', '');
      }
      if (!this.#frame) this.#frame = requestAnimationFrame(() => this.#tick());
    }, { signal, passive: true });

    document.documentElement.addEventListener('pointerleave', () => this.removeAttribute('data-active'), { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #tick() {
    this.#x += (this.#tx - this.#x) * 0.12;
    this.#y += (this.#ty - this.#y) * 0.12;
    this.style.transform = `translate3d(${this.#x}px, ${this.#y}px, 0)`;
    const settled = Math.abs(this.#tx - this.#x) < 0.5 && Math.abs(this.#ty - this.#y) < 0.5;
    this.#frame = settled ? 0 : requestAnimationFrame(() => this.#tick());
  }
}

if (!customElements.get('s-cursor-glow')) customElements.define('s-cursor-glow', SCursorGlow);
